/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const FormIcon: FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path
        clipRule="evenodd"
        d="M4 8C4 6.89543 4.89543 6 6 6H26C27.1046 6 28 6.89543 28 8V24C28 25.1046 27.1046 26 26 26H6C4.89543 26 4 25.1046 4 24V8ZM12 8H26V12H12V8ZM12 14H26V18H12V14ZM10 18V14H6V18H10ZM6 20H10V24H6V20ZM12 20H26V24H12V20ZM10 8V12H6V8H10Z"
        fillRule="evenodd"
      />
    </BaseIcon>
  );
};
